import Stack from '@mui/material/Stack';
import MuiTablePagination from '@mui/material/TablePagination';
import React from 'react';
import IconButton from '../IconButton/IconButton';
import Select from '../form/Select';
import { ChevronLeftIcon, ChevronRightIcon } from '../icons';

const TablePagination = ({
  pagination,
  page,
  count,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  function defaultLabelDisplayedRows({ from, to, count, page }) {
    if (count === -1) return null;
    const totalPages = Math.ceil(count / rowsPerPage);
    return `Page ${page + 1} of ${totalPages}`;
  }

  return (
    <MuiTablePagination
      sx={{
        bgcolor: 'background.paper3',
      }}
      rowsPerPageOptions={pagination.rowsPerPageOptions || [5, 10, 25]}
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelDisplayedRows={defaultLabelDisplayedRows}
      labelRowsPerPage="Per Page"
      slots={{
        toolbar: Stack,
        spacer: () => null,
        select: (props) => {
          return (
            <Select
              transformValue
              menuPosition="fixed"
              margin="none"
              size="mini"
              value={props.value}
              onChange={(v) => props.onChange({ target: { value: v } })}
              options={props.ownerState.rowsPerPageOptions.map((option) => ({
                label: option,
                value: option,
              }))}
              sx={{ width: 80, ml: 2 }}
            />
          );
        },
        actions: {
          nextButton: ({ onClick, disabled }) => {
            return (
              <IconButton
                disabled={disabled}
                onClick={onClick}
                size="mini"
                variant="contained"
                icon={<ChevronRightIcon />}
              />
            );
          },
          previousButton: ({ onClick, disabled }) => {
            return (
              <IconButton
                disabled={disabled}
                sx={{ mr: 1 }}
                onClick={onClick}
                size="mini"
                variant="contained"
                icon={<ChevronLeftIcon />}
              />
            );
          },
        },
      }}
      slotProps={{
        toolbar: {
          direction: 'row',
          alignItems: 'center',
          sx: {
            p: 1.5,
          },
        },
        actions: {
          nextButton: {
            variant: 'outlined',
          },
          previousButton: {
            variant: 'outlined',
          },
        },
        displayedRows: {
          sx: {
            fontWeight: 500,
            color: 'text.secondary',
            ml: 'auto',
            mr: 2,
            my: 0,
          },
        },
        selectLabel: {
          sx: {
            fontWeight: 500,
            color: 'text.secondary',
            m: 0,
          },
        },
      }}
    />
  );
};

export default TablePagination;
